import DevelopKHImage from 'assets/images/develop.png';
import EngagementKHImage from 'assets/images/engagement_kh.png';
import FeedbackKHImage from 'assets/images/feedback_kh.png';
import GettingStartedKHImage from 'assets/images/getting_started_kh.png';
import GoalsKHImage from 'assets/images/goals_kh.png';
import IntegrationsKHImage from 'assets/images/integrations_kh.png';
import OneOnOneKHImage from 'assets/images/one_on_one_kh.png';
import PerformanceReviewKHImage from 'assets/images/performance_review_kh.png';

// Knowledge Hub links for all the "i" icons
export const KH_LINKS = {
  CREATE_GOAL: {
    description: 'Create, update and manage your goals, all from a single window. Click to checkout the process.',
    url: 'https://peoplemesh.zendesk.com/hc/en-us/articles/4621558405149-Creating-Goals-OKRs',
  },

  GOAL_PROGRESS: {
    description: 'Track your progress, add details and provide feedback from here. Click to checkout the process.',
    url: 'https://peoplemesh.zendesk.com/hc/en-us/articles/4621614680733-Updating-Goals-OKRs',
  },

  GOAL_WEIGHTAGE: {
    description: 'Prioritise your goals by assigning different weightages to them. Click to checkout the process.',
    url: 'https://peoplemesh.zendesk.com/hc/en-us/articles/4621630844189-Understanding-Privacy-Weightage-of-Goals-in-Mesh',
  },

  TEAMHUB_VIEW: {
    description:
      'Keep an eye on your team progress with respect to individual Initiatives and goals. Click to checkout the process.',
    url: 'https://peoplemesh.zendesk.com/hc/en-us/articles/4621696241949-Creating-cascading-Goals-OKRs-for-Team-Members',
  },

  TEAMHUB_VIEW_2: {
    description:
      'Conduct periodic check-ins with your team effortlessly through the team hub. Click to checkout the process.',
    url: 'https://support.mesh.ai/hc/en-us/articles/4621510277277-Initiatives',
  },

  TEAMHUB_VIEW_GOALS: {
    description:
      'Get more structured view of Goals and conduct periodic check-ins effortlessly with this page. Click to learn more.',
    url: 'https://peoplemesh.zendesk.com/hc/en-us/articles/4621685266973-Goals-OKRs-Check-ins',
  },

  TEAMHUB_VIEW_TASKS: {
    description:
      'Get more structured view of Initiatives and conduct periodic check-ins effortlessly with this page. Click to learn more.',
    url: 'https://peoplemesh.zendesk.com/hc/en-us/articles/4621685266973-Goals-OKRs-Check-ins',
  },

  OBJECTIVES: {
    description: 'Start creating and updating company-wide objectives from here. Click to checkout the process.',
    url: 'https://peoplemesh.zendesk.com/hc/en-us/articles/4621517751837-Goal-Objectives',
  },

  TASK_TAGS: {
    description: 'Create and track competencies to measure overall progress and performance of individuals',
    url: 'https://support.mesh.ai/hc/en-us/categories/4619028472093-Continuous-Feedback',
  },

  COHORTS: {
    description:
      'Cohorts let you track employee performance within specific employee groups based on certain parameters like function, location, etc. Click to checkout the process. ',
    url: 'https://peoplemesh.zendesk.com/hc/en-us/articles/4621731769629-Building-Cohorts',
  },

  GROUPING_INDIVIDUAL: {
    description:
      'Review goals of the cohort selected on the basis of individual grouping. Click to checkout the process.',
    url: 'https://peoplemesh.zendesk.com/hc/en-us/articles/4621716228125-Review-Goals-OKRs-Progress-via-Individuals',
  },

  GROUPING_OBJECTIVE: {
    description:
      'Review goals of the cohort selected on the basis of objectives grouping. Click to checkout the process.',
    url: 'https://peoplemesh.zendesk.com/hc/en-us/articles/4621755670045-Review-Goals-OKRs-Progress-via-Objectives',
  },

  REVIEW_QB: {
    description: 'Click to checkout the process of creating questions for your review cycles.',
    url: 'https://peoplemesh.zendesk.com/hc/en-us/articles/4621763108509-Question-Bank',
  },

  REVIEW_TEMPLATES: {
    description: 'Click to checkout the process of creating review templates to be used in your review cycles.',
    url: 'https://peoplemesh.zendesk.com/hc/en-us/articles/4621719153437-Review-Templates',
  },

  REVIEW_CYCLE: {
    description: 'Click to checkout the process for creating and updating review cycles from here.',
    url: 'https://peoplemesh.zendesk.com/hc/en-us/articles/4621753085085-Creating-a-Review-Cycle-Review-Process-',
  },

  REVIEW_REMINDERS: {
    description: 'If there are no preferred channels, employees will always receive emails.',
    url: '',
  },

  ACTIVE_REVIEWS: {
    description:
      "Here you'll see the reviews you've been nominated to fill and the pending feedback requests. Click to learn more.",
    url: 'https://peoplemesh.zendesk.com/hc/en-us/articles/4621785250589-Writing-Reviews-for-your-Direct-Reports',
  },

  ONE_ON_ONE_QB: {
    description: 'Click to checkout the process on how you can go about creating questions for your 1:1s.',
    url: 'https://peoplemesh.zendesk.com/hc/en-us/articles/4621509836701-Question-Bank',
  },

  ONE_ON_ONE_TEMPLATES: {
    description: 'Click to checkout the process of creating review templates to be used in your 1:1s.',
    url: 'https://peoplemesh.zendesk.com/hc/en-us/articles/4621577836189-1-1-Templates',
  },

  ONE_ON_ONE_CREATION: {
    description: 'Click to checkout the process for creating new 1:1s and editing the timelines.',
    url: 'https://peoplemesh.zendesk.com/hc/en-us/articles/4621580991773-My-Preferences-Settings',
  },

  ONE_ON_ON_GUIDE: {
    description: 'Checkout the process for flawlessly conducting 1:1s with your team members.',
    url: 'https://peoplemesh.zendesk.com/hc/en-us/articles/4621567414173-Conducting-1-1s-with-your-direct-reports',
  },

  ONE_ON_ONE_ANALYTICS: {
    description:
      'Take a look at the 1:1 performance of managers / their team members via the 1:1 Analytics. Click to checkout the process. ',
    url: 'https://peoplemesh.zendesk.com/hc/en-us/articles/4621586000413-Understanding-1-1-Analytics',
  },

  JIRA: {
    description:
      'If your team already uses Jira then you can connect it to Mesh to stay on top of your goals and objectives. Click to checkout the process.',
    url: 'https://peoplemesh.zendesk.com/hc/en-us/articles/4621379531165-Jira-Integration-with-Mesh',
  },

  SALESFORCE: {
    description:
      'If your team already uses Salesforce then you can connect it to Mesh to stay on top of your goals and objectives. Click to checkout the process.',
    url: 'https://peoplemesh.zendesk.com/hc/en-us/articles/4621444024477-Salesforce-Integration-with-Mesh',
  },

  SLACK: {
    description:
      'If your company uses Slack then you can connect it to Mesh for managing your goals/ OKRs, requesting feedback, etc. all within your Slack. Click to checkout the process.',
    url: 'https://peoplemesh.zendesk.com/hc/en-us/articles/4621351163549-Slack-Integration-with-Mesh',
  },

  MS_TEAM: {
    description:
      'If your company uses MS Teams, you can connect it to Mesh for managing your Goals/Initiatives within MS Teams.',
    url: 'https://peoplemesh.zendesk.com/hc/en-us/articles/4621391999517-Microsoft-Teams-Integration-with-Mesh',
  },

  FEEDBACK_ANALYTICS: {
    description:
      'See how well your employees are aligned to the company’s core competencies via the feedback analytics. Click to checkout the process.',
    url: 'https://peoplemesh.zendesk.com/hc/en-us/articles/4621478863261-Understanding-Feedback-Analytics',
  },

  FEEDBACK_PRIVATE_PUBLIC: {
    description:
      'There are multiple ways to give and receive feedback on Mesh with option to make them private or public. Click to checkout the process.',
    url: 'https://peoplemesh.zendesk.com/hc/en-us/articles/4621457089821-Giving-Receiving-Feedback',
  },

  COMPETENCIES: {
    description: 'Create and track competencies to measure overall progress and performance of individuals',
    url: 'https://peoplemesh.zendesk.com/hc/en-us/articles/4621478863261-Understanding-Feedback-Analytics',
  },

  ENGAGEMENT_SURVEYS: {
    description:
      'Create multiple engagement surveys with ease for specific teams as well as entire organization via engagement surveys. Click to checkout the process.',
    url: 'https://knowledge.mesh.ai/hc/en-in/sections/12187277724829-Engagement-Module-Preferences',
  },

  ENGAGEMENT_DRIVERS: {
    description:
      'Create/ view all your engagement drivers from here and tag your survey questions to these drivers. Click to checkout the process. ',
    url: 'https://knowledge.mesh.ai/hc/en-in/sections/12187277724829-Engagement-Module-Preferences',
  },

  ENGAGEMENT_QB: {
    description: 'Click to checkout the process of creating questions for your engagement surveys.',
    url: 'https://peoplemesh.zendesk.com/hc/en-us/articles/4621663958301-Engagement-Settings',
  },

  ENGAGEMENT_MODULE: {
    description:
      'Click to checkout the process for getting employees to find and fill active surveys and see the results from their completed engagement surveys. ',
    url: 'https://peoplemesh.zendesk.com/hc/en-us/articles/4621684410013-Understanding-Engagement-Module',
  },

  ENGAGEMENT_TEMPLATES: {
    description: 'Click to checkout the process of creating engagement templates to be used in your pulse surveys.',
    url: 'https://knowledge.mesh.ai/hc/en-in/sections/12187277724829-Engagement-Module-Preferences',
  },

  ENGAGEMENT_ANALYTICS: {
    description:
      "Click to checkout how engaged different cohorts of employees are to your company's engagement drivers.",
    url: 'https://peoplemesh.zendesk.com/hc/en-us/articles/4621684410013-Understanding-Engagement-Module',
  },

  ENGAGEMENT_REMINDERS: {
    description: 'If there are no preferred channels, employees will always receive emails.',
    url: '',
  },

  GOAL_PANEL_COMMENTS: {
    description:
      "The comments section functions as a logbook to capture every update that's made on the particular goal. Users can also praise peers and seek resolution on blockers here.",
    url: '',
  },

  REVIEW_CALIBRATION_RABBIT: {
    description: 'Learn how to calibrate on Mesh',
    url: 'https://knowledge.mesh.ai/hc/en-in/articles/9598987238173',
  },

  PARTIAL_PUBLISH_SHARE_RESULTS: {
    description: 'Learn how to share results on Mesh',
    url: 'https://knowledge.mesh.ai/hc/en-in/articles/13277133122333-Share-performance-snapshots',
  },
};

// Knowledge hub links for help center

export const KH_LINKS_HELP_CENTER = [
  {
    heading: 'Getting Started 🤓',
    subText: "New to Mesh? Here's all the necessary information to get you off the ground",
    src: GettingStartedKHImage,
    url: 'https://knowledge.mesh.ai/hc/en-in/categories/9313902342429-Getting-Started-',
  },
  {
    heading: 'Goals 🎯',
    subText: "Here's everything to help you achieve mastery for managing Goals/ OKRs on Mesh",
    src: GoalsKHImage,
    url: 'https://knowledge.mesh.ai/hc/en-in/categories/9314216314141-Goals-',
  },
  {
    heading: 'Reviews 📝',
    subText: 'Learn how to run effortless performance reviews on the Mesh platform',
    src: PerformanceReviewKHImage,
    url: 'https://knowledge.mesh.ai/hc/en-in/categories/9315735651101-Reviews-',
  },
  {
    heading: 'Initiatives ✅',
    subText: 'Understand the easy way to create and track projects using Mesh',
    src: GoalsKHImage,
    url: 'https://knowledge.mesh.ai/hc/en-in/categories/9318899869085-Initiatives-',
  },
  {
    heading: 'Engagement 💛',
    subText: 'Measuring employee engagement through NPS surveys has never been easier',
    src: EngagementKHImage,
    url: 'https://knowledge.mesh.ai/hc/en-in/categories/9317588349469-Engagement-',
  },
  {
    heading: '1:1s 💬',
    subText: 'Take a look at how Mesh simplifies effective 1:1s for organizations of all sizes',
    src: OneOnOneKHImage,
    url: 'https://knowledge.mesh.ai/hc/en-in/categories/9317793350941-1-1s-',
  },
  {
    heading: 'Feedback 🏆',
    subText: 'Mesh makes giving and receiving feedback very simple for remote & hybrid companies',
    src: FeedbackKHImage,
    url: 'https://knowledge.mesh.ai/hc/en-in/categories/9318298371101-Feedback-',
  },
  {
    heading: 'Develop 🚀',
    subText: 'Plan the career advancement for your employees easily',
    src: DevelopKHImage,
    url: 'https://knowledge.mesh.ai/hc/en-in/categories/9319290213277-Develop-',
  },
  {
    heading: 'Integrations 👩‍💻',
    subText: 'Connect with all your favorite tools and use Mesh from right within them',
    src: IntegrationsKHImage,
    url: 'https://knowledge.mesh.ai/hc/en-in/categories/9319911244189-Integrations-',
  },
];
